import axios from '../http'

function query(data) {
    return axios.post('/event/medal/query', data);
}

function counting() {
    return axios.post('/event/medal/counting');
}



function exportMedal(data){
    const url =  "/event/medal/exportMedal";
    return axios.post(url, data, { responseType: 'blob' }).then((res) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = "Medal Standings.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    })
}

function printMedal(projectId) {
    const url = "/event/medal/printMedal?projectId="+projectId;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

export default {
    query,
    exportMedal,
    printMedal,
    counting
}